import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CHAT_GPT, ZAPIER } from 'drapcode-constant';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import ExternalApiHeaderNav from './ExternalApiHeaderNav';
import ZapierExternalApiForm from './zapier/ZapierExternalApiForm';
import ParentContentCard from '../common/ParentContentCard';
import ParentDocCard from '../common/ParentDocCard';
import { parseExtractPluginCode } from '../../common/utils/plugin_utils';
import { checkToShowSaveBtn } from '../plugin/utils';
import { checkExternalAPIPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class ExternalZapierCreate extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { headers: [] };

  componentDidMount = () => {
    const { match, home, actions } = this.props;
    const { projectId, externalApiId, version } = match.params;
    const { iPlugins } = home;
    actions.loadCollections({ projectId, version });
    const headers = parseExtractPluginCode(iPlugins, 'EXTERNALAPI');
    this.setState({ headers });
    actions.loadProjectDetail({ projectId, version });
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { home: nextHome, match } = nextProps;
    const { home } = this.props;
    const { iPlugins: nextIPlugins } = nextHome;
    if (!nextIPlugins || nextIPlugins.length === 0) {
      return true;
    }
    const { iPlugins } = home;
    if (!checkToShowSaveBtn(nextIPlugins, iPlugins)) {
      const headers = parseExtractPluginCode(nextIPlugins, 'EXTERNALAPI');
      this.setState({ headers });
    }
    return true;
  }
  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.common;
    if (prevProps.common.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }

  render() {
    const isAllowed = checkExternalAPIPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Zapier" />;
    }
    const { projectId, version } = this.props.match.params;
    const { iPlugins } = this.props.home;
    const chatGptPlugin = iPlugins && iPlugins.find((e) => e.code === CHAT_GPT);
    const { headers } = this.state;
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <ExternalApiHeaderNav
              version={version}
              activeTab={ZAPIER}
              projectId={projectId}
              headers={headers}
              enableChatGpt={chatGptPlugin ? true : false}
            />
            <div className="row mx-auto">
              <ParentContentCard icon={ZAPIER} title="Zapier">
                <ZapierExternalApiForm
                  projectId={projectId}
                  externalApiId={''}
                  history={this.props.history}
                  externalApiType={ZAPIER}
                  actions={this.props.actions}
                  externalapi={this.props.externalapi}
                  version={version}
                />
              </ParentContentCard>
              <ParentDocCard>
                <h5>
                  <b>About Zapier API</b>
                </h5>
                <p>
                  DrapCode supports Zapier to send or process data using Zapier API integration.
                </p>
                <br />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalApi: state.externalApi,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalZapierCreate);
